import { buttonLink } from '@insify/css/classes.module.css';
import { Modal } from '@insify/design-system/components';
import { textColor, textMd } from '@insify/design-system/typography';
import { TrackedButton } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useState } from 'react';

import type { ReactNode } from 'react';

export const ButtonWithModal = ({
  buttonText,
  modalClassName,
  children,
}: {
  buttonText: string;
  modalClassName?: string;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <TrackedButton type='button' className={clsx(textMd, buttonLink)} onClick={() => setIsOpen(true)}>
        {buttonText}
      </TrackedButton>
      <Modal
        trackingId={buttonText}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className={clsx(textColor, textMd, modalClassName)}
      >
        {children}
      </Modal>
    </>
  );
};
